type PromiseResult<T> = {
  data: T | null;
  error: Error | null;
};

/**
 * Wraps a promise in a try-catch block and returns a type-safe result object
 * @param promise The promise to wrap
 * @returns A Promise that resolves to an object containing either the data or error
 */
export async function safePromise<T>(
  promise: Promise<T>,
): Promise<PromiseResult<T>> {
  try {
    const data = await promise;
    return {
      data,
      error: null,
    };
  } catch (error) {
    return {
      data: null,
      error: error instanceof Error ? error : new Error(String(error)),
    };
  }
}
